<header
  class="header-app sticky top-0 flex w-full bg-[var(--pc-bg-base)] border-[var(--pc-border)] z-99999 xl:border-b transition-all duration-300 ease-in-out">
  <div class="flex flex-col items-center justify-between grow xl:flex-row xl:px-6">
    <div
      class="flex items-center justify-between w-full gap-2 px-3 py-3 border-b border-gray-200 dark:border-gray-800 sm:gap-4 xl:justify-normal xl:border-b-0 xl:px-0 lg:py-4">
      <!-- Logo de marca: solo en modo 'topnav' y en escritorio (donde el sidebar —que normalmente
           lo aloja— queda oculto). Enlaza al inicio. -->
      @if (navLayout() === 'topnav') {
        <a routerLink="/inicio" class="hidden xl:flex items-center flex-shrink-0 mr-2"
           [attr.aria-label]="'PartnerCore'">
          <img src="images/logo/Partner-Core-Large.webp" alt="PartnerCore" class="h-[46px] w-auto dark:hidden" />
          <img src="images/logo/Partner-Core-Large-Dark.webp" alt="PartnerCore" class="hidden h-[46px] w-auto dark:block" />
        </a>
      }
      <button
        class="items-center justify-center w-10 h-10 text-gray-500 border-gray-200 rounded-lg z-99999 dark:border-gray-800 flex dark:text-gray-400 lg:h-11 lg:w-11 xl:border transition-all duration-200 hover:bg-gray-100 dark:hover:bg-white/[0.05]"
        [ngClass]="{
          'bg-gray-100 dark:bg-white/[0.03]': isMobileOpen() || isExpanded(),
          'xl:hidden': navLayout() === 'topnav'
        }"
        (click)="handleToggle()"
        [attr.aria-label]="(isExpanded() ? 'layout.topbar.collapseSidebar' : 'layout.topbar.expandSidebar') | transloco"
        [title]="(isExpanded() ? 'layout.topbar.collapseSidebar' : 'layout.topbar.expandSidebar') | transloco">
        
        <!-- MÓVIL: Usar solo isMobileOpen$ -->
        <span class="xl:hidden">
          @if (isMobileOpen()) {
            <!-- Cross Icon -->
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M6.21967 7.28131C5.92678 6.98841 5.92678 6.51354 6.21967 6.22065C6.51256 5.92775 6.98744 5.92775 7.28033 6.22065L11.999 10.9393L16.7176 6.22078C17.0105 5.92789 17.4854 5.92788 17.7782 6.22078C18.0711 6.51367 18.0711 6.98855 17.7782 7.28144L13.0597 12L17.7782 16.7186C18.0711 17.0115 18.0711 17.4863 17.7782 17.7792C17.4854 18.0721 17.0105 18.0721 16.7176 17.7792L11.999 13.0607L7.28033 17.7794C6.98744 18.0722 6.51256 18.0722 6.21967 17.7794C5.92678 17.4865 5.92678 17.0116 6.21967 16.7187L10.9384 12L6.21967 7.28131Z"
                fill="currentColor" />
            </svg>
          } @else {
            <!-- Hamburger Icon -->
            <svg width="16" height="12" viewBox="0 0 16 12" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M0.583252 1C0.583252 0.585788 0.919038 0.25 1.33325 0.25H14.6666C15.0808 0.25 15.4166 0.585786 15.4166 1C15.4166 1.41421 15.0808 1.75 14.6666 1.75L1.33325 1.75C0.919038 1.75 0.583252 1.41422 0.583252 1ZM0.583252 11C0.583252 10.5858 0.919038 10.25 1.33325 10.25L14.6666 10.25C15.0808 10.25 15.4166 10.5858 15.4166 11C15.4166 11.4142 15.0808 11.75 14.6666 11.75L1.33325 11.75C0.919038 11.75 0.583252 11.4142 0.583252 11ZM1.33325 5.25C0.919038 5.25 0.583252 5.58579 0.583252 6C0.583252 6.41421 0.919038 6.75 1.33325 6.75L7.99992 6.75C8.41413 6.75 8.74992 6.41421 8.74992 6C8.74992 5.58579 8.41413 5.25 7.99992 5.25L1.33325 5.25Z"
                fill="currentColor" />
            </svg>
          }
        </span>

        <!-- DESKTOP: Usar solo isExpanded$ -->
        <span class="hidden xl:block">
          @if (isExpanded()) {
            <!-- Cross Icon -->
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M6.21967 7.28131C5.92678 6.98841 5.92678 6.51354 6.21967 6.22065C6.51256 5.92775 6.98744 5.92775 7.28033 6.22065L11.999 10.9393L16.7176 6.22078C17.0105 5.92789 17.4854 5.92788 17.7782 6.22078C18.0711 6.51367 18.0711 6.98855 17.7782 7.28144L13.0597 12L17.7782 16.7186C18.0711 17.0115 18.0711 17.4863 17.7782 17.7792C17.4854 18.0721 17.0105 18.0721 16.7176 17.7792L11.999 13.0607L7.28033 17.7794C6.98744 18.0722 6.51256 18.0722 6.21967 17.7794C5.92678 17.4865 5.92678 17.0116 6.21967 16.7187L10.9384 12L6.21967 7.28131Z"
                fill="currentColor" />
            </svg>
          } @else {
            <!-- Hamburger Icon -->
            <svg width="16" height="12" viewBox="0 0 16 12" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M0.583252 1C0.583252 0.585788 0.919038 0.25 1.33325 0.25H14.6666C15.0808 0.25 15.4166 0.585786 15.4166 1C15.4166 1.41421 15.0808 1.75 14.6666 1.75L1.33325 1.75C0.919038 1.75 0.583252 1.41422 0.583252 1ZM0.583252 11C0.583252 10.5858 0.919038 10.25 1.33325 10.25L14.6666 10.25C15.0808 10.25 15.4166 10.5858 15.4166 11C15.4166 11.4142 15.0808 11.75 14.6666 11.75L1.33325 11.75C0.919038 11.75 0.583252 11.4142 0.583252 11ZM1.33325 5.25C0.919038 5.25 0.583252 5.58579 0.583252 6C0.583252 6.41421 0.919038 6.75 1.33325 6.75L7.99992 6.75C8.41413 6.75 8.74992 6.41421 8.74992 6C8.74992 5.58579 8.41413 5.25 7.99992 5.25L1.33325 5.25Z"
                fill="currentColor" />
            </svg>
          }
        </span>
      </button>
      <!-- Logo de la empresa: enlaza al detalle de la empresa seleccionada (si el usuario puede verla) -->
      <div class="general-company">
        <div class="general-company-left">
          @if (companyDetailLink(); as detailLink) {
            <a [routerLink]="detailLink" class="cursor-pointer"
               [title]="'layout.topbar.viewCompanyDetail' | transloco"
               [attr.aria-label]="'layout.topbar.viewCompanyDetail' | transloco">
              <img class="image-logo-selected-company dark:hidden" [src]="imgLogo()" alt="Logo de la empresa" (error)="onLogoError()" />
              <img class="image-logo-selected-company-dark hidden dark:block" [src]="imgLogo()" alt="Logo de la empresa" (error)="onLogoError()" />
            </a>
          } @else {
            <span>
              <img class="image-logo-selected-company dark:hidden" [src]="imgLogo()" alt="Logo de la empresa" (error)="onLogoError()" />
              <img class="image-logo-selected-company-dark hidden dark:block" [src]="imgLogo()" alt="Logo de la empresa" (error)="onLogoError()" />
            </span>
          }
        </div>
        <div class="general-company-right">
          <app-select-search
            [datalist]="companyOptions()"
            [ngModel]="selectedCompany()"
            [behaveAsSelect]="true"
            (ngModelChange)="onCompanySelected($event)"
            [placeholder]="'layout.topbar.selectCompany' | transloco"
          ></app-select-search>
        </div>
      </div>
      <button (click)="toggleApplicationMenu()"
        class="flex items-center justify-center w-10 h-10 text-gray-700 rounded-lg z-99999 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-800 xl:hidden">
        <!-- Dots Icon -->
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M5.99902 10.4951C6.82745 10.4951 7.49902 11.1667 7.49902 11.9951V12.0051C7.49902 12.8335 6.82745 13.5051 5.99902 13.5051C5.1706 13.5051 4.49902 12.8335 4.49902 12.0051V11.9951C4.49902 11.1667 5.1706 10.4951 5.99902 10.4951ZM17.999 10.4951C18.8275 10.4951 19.499 11.1667 19.499 11.9951V12.0051C19.499 12.8335 18.8275 13.5051 17.999 13.5051C17.1706 13.5051 16.499 12.8335 16.499 12.0051V11.9951C16.499 11.1667 17.1706 10.4951 17.999 10.4951ZM13.499 11.9951C13.499 11.1667 12.8275 10.4951 11.999 10.4951C11.1706 10.4951 10.499 11.1667 10.499 11.9951V12.0051C10.499 12.8335 11.1706 13.5051 11.999 13.5051C12.8275 13.5051 13.499 12.8335 13.499 12.0051V11.9951Z"
            fill="currentColor" />
        </svg>
      </button>
    </div>
    <!-- Menú de aplicaciones (tema / notificaciones / usuario): en móvil se despliega
         con animación de alto (grid 0fr→1fr) para que el contenido de abajo no baje de
         golpe; en xl+ siempre visible como fila. Ver .app-menu-reveal en styles.css. -->
    <div class="app-menu-reveal w-full" [class.is-open]="isApplicationMenuOpen()">
      <div class="app-menu-reveal-inner">
        <div class="flex items-center justify-between w-full gap-4 px-5 py-4 shadow-theme-md xl:justify-end xl:px-0 xl:shadow-none">
      <div class="flex items-center gap-2 2xsm:gap-3">
        <!-- Badge del plan activo del cliente (oculto en pantallas muy pequeñas para no saturar).
             Si el cliente tiene planes en varios productos, el badge abre un popover con el desglose. -->
        @if (planPrimary(); as plan) {
          <div class="relative hidden sm:block">
            <button type="button"
              class="inline-flex items-center rounded-full transition-opacity hover:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-400/50"
              (click)="togglePlanMenu()"
              [attr.aria-expanded]="planMenuOpen()"
              [attr.aria-haspopup]="true"
              [title]="planInTrial()
                ? ('layout.plan.trialLeft' | transloco: { days: planTrialDays() })
                : ('layout.plan.activeTitle' | transloco: { plan: plan.planName })">
              <app-badge [color]="planBadgeColor()" variant="light" size="sm">
                <span class="inline-flex items-center gap-1">
                  <i [class]="plan.planIcon || 'bi bi-patch-check-fill'"></i>
                  <span class="max-w-[10rem] truncate">{{ plan.planName }}</span>
                  @if (planInTrial()) {
                    <span class="opacity-80">· {{ 'layout.plan.trialTag' | transloco }}</span>
                  }
                  @if (planHasMultiple()) {
                    <span class="ml-0.5 inline-flex items-center rounded-full bg-black/5 px-1.5 py-px text-[10px] font-bold leading-none tabular-nums dark:bg-white/15">
                      +{{ planList().length - 1 }}
                    </span>
                  }
                  <i class="bi bi-chevron-down ml-0.5 flex items-center text-[10px] leading-none transition-transform duration-200"
                     [class.rotate-180]="planMenuOpen()" aria-hidden="true"></i>
                </span>
              </app-badge>
            </button>

            @if (planMenuOpen()) {
              <!-- Capa para cerrar al hacer clic fuera -->
              <div class="fixed inset-0 z-40" (click)="closePlanMenu()" aria-hidden="true"></div>

              <!-- Popover: planes activos por producto (estándar billing/suscripciones).
                   Se acomoda al viewport igual que el dropdown de notificaciones: en pantallas chicas
                   el badge queda a la IZQUIERDA (menú con justify-between), así que se ancla a la
                   izquierda; solo en xl+ (badge a la derecha) se ancla a la derecha. El ancho se
                   clampa a `100vw - margen` para no desbordar. -->
              <div class="absolute left-0 xl:left-auto xl:right-0 z-50 mt-2 w-[min(18rem,calc(100vw_-_1.5rem))] overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-theme-lg dark:border-gray-700 dark:bg-gray-900"
                   role="menu">
                <div class="border-b border-gray-100 px-4 py-2.5 dark:border-gray-800">
                  <p class="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
                    {{ 'layout.plan.activePlans' | transloco }}
                  </p>
                </div>

                <ul class="max-h-[60vh] overflow-y-auto py-1.5 custom-scrollbar">
                  @for (p of planList(); track p.productCode) {
                    <li class="flex items-center gap-3 px-4 py-2">
                      <span class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-brand-50 text-base text-brand-500 ring-1 ring-inset ring-brand-100 dark:bg-brand-500/15 dark:text-brand-300 dark:ring-brand-500/20">
                        <i [class]="p.planIcon || 'bi bi-patch-check-fill'"></i>
                      </span>
                      <div class="min-w-0 flex-1">
                        <p class="truncate text-[11px] font-medium uppercase tracking-wide text-gray-400 dark:text-gray-500">{{ productLabel(p) }}</p>
                        <p class="truncate text-sm font-semibold text-gray-800 dark:text-white">{{ p.planName }}</p>
                      </div>
                      @if (subInTrial(p)) {
                        <span class="inline-flex shrink-0 items-center gap-1 rounded-full bg-warning-50 px-2 py-0.5 text-[10px] font-semibold text-warning-600 dark:bg-warning-500/15 dark:text-warning-400">
                          <i class="bi bi-hourglass-split"></i>{{ 'layout.plan.trialDaysShort' | transloco: { days: subTrialDays(p) } }}
                        </span>
                      } @else {
                        <span class="h-2 w-2 shrink-0 rounded-full bg-success-500 ring-2 ring-success-500/25" [title]="'profile.plan.statusActive' | transloco" aria-hidden="true"></span>
                      }
                    </li>
                  }
                </ul>

                <a routerLink="/admin/perfil" (click)="closePlanMenu()"
                   class="flex items-center justify-between gap-2 border-t border-gray-100 px-4 py-2.5 text-sm font-medium text-brand-600 transition-colors hover:bg-brand-50/60 dark:border-gray-800 dark:text-brand-400 dark:hover:bg-brand-500/10">
                  {{ 'layout.plan.viewInProfile' | transloco }}
                  <i class="bi bi-arrow-right" aria-hidden="true"></i>
                </a>
              </div>
            }
          </div>
        }
        <!-- ThemeToggleButton placeholder -->
        <app-theme-toggle-button />
        <!-- NotificationDropdown placeholder -->
        <app-notification-icon />
      </div>
      <!-- UserDropdown placeholder -->
      <app-user-dropdown />
        </div>
      </div>
    </div>
  </div>
</header>